import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { CreateFollowRequestDto } from '../../types';

export const useCreateFollow = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ payload, firebaseToken }: { payload: CreateFollowRequestDto; firebaseToken: string }) => {
      const { data } = await apiClient.post('/v1/follows/', payload, {
        headers: {
          Authorization: `Bearer ${firebaseToken}`,
        },
      });
      return data;
    },
    onSuccess: (_, { firebaseToken }) => {
      queryClient.invalidateQueries({ queryKey: ['follows', firebaseToken] });
    },
    scope: {
      // Serialize mutations with the same scope
      id: 'follow',
    },
  });
};
